import { render } from "./ProjectManage.vue?vue&type=template&id=d52a6b10&scoped=true"
import script from "./ProjectManage.vue?vue&type=script&lang=js"
export * from "./ProjectManage.vue?vue&type=script&lang=js"

import "./ProjectManage.vue?vue&type=style&index=0&id=d52a6b10&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52a6b10"]])

export default __exports__